
import './style.scss'
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
// import { userStateData } from '../../data/userStateData';
import { setDataLoadRequestFinished } from '../../redux/reducers/userSlice';
import { setSubPage } from '../../redux/reducers/dashboardSlice';
import { DashboardSubPages } from '../../types/types';
import { adminConnector } from '../../server/connector/adminConnector';
import AdminSideMenu from '../../sections/adminSideMenu/AdminSideMenu';
import AdminHeader from '../../sections/adminHeader/AdminHeader';
import AdminInstructorProfileContentArea from '../../sections/adminInstructorProfileContentArea/AdminInstructorProfileContentArea';
import { useCookies } from 'react-cookie';
import { adminStateData } from '../../data/adminStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';

function AdminInstructor() {
	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)
	const dispatch = useAppDispatch()
	const [cookies] = useCookies()

	useEffect(() => {
		// set subpage for side menu highlighting
		// dispatch(setSubPage(DashboardSubPages.MAIN))
		// // check if log in has been checked and confirmed in App.tsx
		// if (loginChecked == true) {
		// 	// confirm a user is logged in
		// 	if (userStateData.loggedIn == false) {
		// 		window.location.replace('/')
		// 	} else {
		// 		// Load user data such as interactions data
		// 		loadProfileData()
		// 	}
		// }
		dispatch(setSubPage(DashboardSubPages.INSTRUCTOR))
		// check if log in has been checked and confirmed in App.tsx
		if (cookies?.adminLogin) {
			adminStateData.loggedIn = cookies?.adminLogin
			loadProfileData()
		} else {
			window.location.replace(PAGE_URLS.ADMIN_LOGIN)
		}
	}, [])

	const loadProfileData = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const profileId: string | null = urlParams.get('id')

		if (adminConnector.requestInProgress) {
			console.log('[Dashboard] - loadProfileData() called while requestInProgress')
		} else {
			if (profileId) {
				adminConnector.performGetAdminInstructorRequest(profileId).then((requestStatus) => {
					if (!requestStatus) {
						console.log('WARNING - [Admin] - performGetAdminCustomersRequest() failed')
					}
					dispatch(setDataLoadRequestFinished(true))
				})
			}
		}
	}

	return (
		<div className='dashboard-wrap'>
			{loginChecked &&
				<>
					<AdminSideMenu />
					<div
						className='dashboard-content-wrap'
					>
						<AdminHeader title='Admin - Instructors' />
						<AdminInstructorProfileContentArea />
					</div>
				</>
			}
		</div>
	)
}

export default AdminInstructor
